import LegalPage from '@/components/LegalPage';

// Mentions légales — LCEN art. 6-III. Share capital and publication director to be completed by the owner.
const sections = [
  { title: 'Éditeur du site / Publisher', blocks: [
    { table: { head: ['', ''], rows: [
      ['Dénomination', 'MINDUNITE SAS'],
      ['Forme juridique', 'Société par actions simplifiée (SAS)'],
      ['Capital social', '[à compléter]'],
      ['SIREN', '990 299 414'],
      ['Siège social', '7 Avenue de Fabron, 06200 Nice, France'],
      ['E-mail', 'legal@chatity.io'],
      ['Directeur de la publication', '[Président de MINDUNITE SAS — à compléter]'],
    ] } },
  ] },
  { title: 'Hébergement / Hosting', blocks: [
    'L\'application et les mini-sites sont hébergés sur l\'infrastructure cloud de la plateforme Emergent (Kubernetes, base de données MongoDB). Les coordonnées détaillées de l\'hébergeur et les régions de traitement figurent sur la page Subprocessors (chatity.io/subprocessors).',
  ] },
  { title: 'Contenus publiés par les professionnels', blocks: [
    'Les mini-sites et widgets accessibles via chatity.io/<nom-du-salon> sont édités par les professionnels concernés, qui sont responsables de leur contenu et de leurs propres mentions légales. Chatity intervient en qualité d\'hébergeur au sens de l\'article 6 de la loi n° 2004-575 du 21 juin 2004 (LCEN) et du règlement (UE) 2022/2065 (DSA).',
    'Point de contact pour les signalements de contenus illicites (LCEN / DSA) : legal@chatity.io — indiquez l\'URL, les motifs et vos coordonnées.',
  ] },
  { title: 'Données personnelles', blocks: [
    'Les traitements de données personnelles sont décrits dans la Politique de confidentialité (chatity.io/privacy) et le Data Processing Agreement (chatity.io/dpa). Contact : privacy@chatity.io. Vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr).',
  ] },
  { title: 'Médiation de la consommation', blocks: [
    'Conformément aux articles L611-1 et suivants du Code de la consommation, tout consommateur peut recourir gratuitement à un médiateur de la consommation après réclamation écrite restée infructueuse. Coordonnées du médiateur sur demande à legal@chatity.io. Plateforme européenne de règlement en ligne des litiges : ec.europa.eu/consumers/odr.',
  ] },
  { title: 'Propriété intellectuelle', blocks: [
    'La marque Chatity, le logo, l\'interface et le code de la plateforme sont la propriété de MINDUNITE SAS. Toute reproduction sans autorisation est interdite.',
  ] },
];

export default function LegalNotice() {
  return <LegalPage testId="legal-notice-page" title="Mentions légales / Legal Notice" updated="October 15, 2026" sections={sections} />;
}
